import { render, staticRenderFns } from "./NewTaskFolderDlg.vue?vue&type=template&id=7ddc3e1c&scoped=true"
import script from "./NewTaskFolderDlg.vue?vue&type=script&lang=js"
export * from "./NewTaskFolderDlg.vue?vue&type=script&lang=js"
import style0 from "./NewTaskFolderDlg.vue?vue&type=style&index=0&id=7ddc3e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc3e1c",
  null
  
)

export default component.exports